module.exports = __webpack_public_path__ + "media/red_open.936d8442.mp3";